// extracted by mini-css-extract-plugin
export var banner = "Banner-module--banner--57991";
export var bannerBtn = "Banner-module--bannerBtn--85fee";
export var bannerContent = "Banner-module--bannerContent--e59a8";
export var bannerText = "Banner-module--bannerText--736a2";